import { hasValue, styles } from "@repo/helpers";
import { ChangeEvent, useCallback, useState } from "react";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { BaseProps } from "./types";

export function Checkbox(props: BaseProps) {
	const { title, large = true, inline = true, ...inputProps } = props;
	const { id, name, value, disabled, label, changeHandler } = inputProps;
	const [focused, setFocused] = useState(false);

	const hideLabel = !hasValue(title);

	const updateFocused = useCallback(() => setFocused(!focused), [focused]);

	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			if (disabled) return;
			if (changeHandler) {
				changeHandler(event.target.checked, id);
			}
		},
		[disabled, changeHandler, id],
	);

	return (
		<InputComponent
			{...inputProps}
			inline={inline}
			hideLabel={hideLabel}
			label={title}
			onFocused={updateFocused}
			onUnfocused={updateFocused}
		>
			{
				<label className={styles(style.checkboxLabel, !inline && hideLabel && style.vertical)}>
					<input
						id={id || name}
						name={name || id}
						type="checkbox"
						className={styles(style.checkbox, large && style.checkboxLarge, "form-check-input")}
						checked={!!value || false}
						disabled={disabled}
						onChange={onChange}
					/>
					{label}
				</label>
			}
		</InputComponent>
	);
}
